import { PaymentPlan } from "./paymentPlan";

const ClassificationGroup = {
    Pricing: "PRICING",
    Matching: "MATCHING",
    Concierge: "CONCIERGE",
    CShip: "C_SHIP"
};
type ClassificationGroup = typeof ClassificationGroup[keyof typeof ClassificationGroup];

export interface PlanListFeature {
    nameJa: string;
    free: string;
    lite: string;
    standard: string;
}

export interface PlanListFeatureGroup {
    groupName: ClassificationGroup;
    items: PlanListFeature[];
}

export const PLAN_LIST_FEATURES: PlanListFeatureGroup[] = [
    {
        groupName: "マッチング",
        items: [
            {
                nameJa: "いいね",
                free: "60名",
                lite: "60名",
                standard: "60名"
            },
            {
                nameJa: "マッチング",
                free: "○",
                lite: "○",
                standard: "○"
            },
            {
                nameJa: "メッセージ",
                free: "",
                lite: "○",
                standard: "○"
            }
        ]
    },
    {
        groupName: "コンシェルジュ",
        items: [
            {
                nameJa: "チャット相談",
                free: "",
                lite: "",
                standard: "○"
            },
            {
                nameJa: "相手紹介",
                free: "",
                lite: "",
                standard: "○"
            },
            {
                nameJa: "専任サポート",
                free: "",
                lite: "",
                standard: "○"
            }
        ]
    },
    {
        groupName: "結婚相談所ネットワーク（コネクトシップ）",
        items: [
            {
                nameJa: "参加",
                free: "",
                lite: "",
                standard: "○"
            },
            {
                nameJa: "参加申請サポート",
                free: "",
                lite: "",
                standard: "○"
            },
            {
                nameJa: "すべての会員閲覧",
                free: "",
                lite: "",
                standard: "○"
            }
        ]
    }
];

interface FeatureTextPart {
    text?: string;
    emphasis?: string;
    annotation?: string;
}

const liteFeatures: FeatureTextPart[][] = [
    [
        { text: "パートナーエージェントApp会員との" },
        { emphasis: "メッセージ" },
        {
            annotation:
                "すべての会員の閲覧はライトプランでは行なえません。スタンダードプランの加入が必要です"
        }
    ]
];

const standardFeatures: FeatureTextPart[][] = [
    [
        { emphasis: "追加料金なし" },
        { text: "で結婚相談所ネットワークへの参加" },
        { annotation: "参加には別途書類提出や規約の同意が必要になります" }
    ],
    [{ emphasis: "専任コンシェルジュ" }, { text: "が活動支援" }],
    [
        { emphasis: "コンシェルジュ面談" },
        { text: "や" },
        { emphasis: "お相手紹介" }
    ],
    [{ emphasis: "全額返金保証制度" }, { text: "あり" }]
];

export const PLAN_FEATURES = {
    [PaymentPlan.Lite1MIosIap1000]: liteFeatures,
    [PaymentPlan.Lite1MCard1000]: liteFeatures,
    [PaymentPlan.Standard1MIosIap12000]: standardFeatures,
    [PaymentPlan.Standard1MCard9800]: standardFeatures
};
